<template>
  <div class="weiVCon">
    <div class="weiViewoBox">
      <div class="weiVItems">
        <ul class="clearfix">
          <li
            class="fl"
            v-for="item in micVideolist"
            :key="item.index"
          >
            <!-- vType:0--不记时视频 1--要计时视频 -->
            <router-link :to="{path:'/videoD',query:{vObj:JSON.stringify(item),vType:0}}">
              <div class="weiVImgBox">
                <img
                  :src="item.imagePath"
                  alt=""
                  class="weiVImg"
                  :onerror="defaultImg"
                />
                <img
                  src="../assets/imgs/playIcon.png"
                  alt=""
                  class="toPlay"
                />
                <span>{{item.dataduration }}</span>
              </div>
              <p class="videoTit">{{item.title}}</p>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import { getPublicCourseware } from '../../src/api/Api'
export default {
  name: 'weiVCon',
  data () {
    return {
      micVideolist: [], // 列表
      defaultImg: 'this.src="' + require('../assets/imgs/banner.png') + '"', // 默认图地址
      baseUrl: window.baseapi.baseApiUrl
    }
  },
  created () {
    this.getPublicCoursewaresAA()
  },
  mounted () {
    window.myVue = this
  },
  methods: {
    getPublicCoursewares () {
      var _this = this
      getPublicCourseware({
        type: 0
      }).then(res => {
        if (res.data.returnCode === 1) {
          _this.micVideolist = res.data.returnDate
        } else {
        }
      })
    },
    getPublicCoursewaresAA () {
      this.$axios({
        method: 'get',
        url: this.baseUrl + '/GetDataService/getPublicCourseware',
        params: { type: 0 }
      }).then(res => {
        if (res.data.returnCode === 1) {
          this.isHasmicVideolist = false
          this.micVideolist = res.data.returnDate
        } else {
          this.isHasmicVideolist = true
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/WeiVideo.vue